import DocumentAPI from 'apis/DocumentAPI';

import { downloadBlob } from 'domain/shared/Files/actions';
import useLazyResource from 'util/resource/useLazyResource';
import { invalidate } from 'hooks/useSWR';
import { documentCenterDocumentsKey, refetchUnreadDocuments } from 'apis/DocumentAPI/useDocuments';
import { companiesApi } from 'apis/CompanyAPI/companies/companiesApi';
import useNotify from 'hooks/useNotify';

export const useDownloadDocument = (companyId: number) => {
  const notify = useNotify();
  return useLazyResource(
    (args: { documentId: string; folderId?: string }) =>
      DocumentAPI.download(companyId, args.documentId).then(response => downloadBlob(response)),
    {
      onSuccess: (_, args) => {
        refetchUnreadDocuments(companyId);
        args.folderId && invalidate(documentCenterDocumentsKey(companyId, args.folderId));
      },
      onFailure: () => notify('error', 'Could not download the document.'),
    },
  );
};

export const useDownloadPitchDocument = (companyId: number) => {
  const notify = useNotify();
  return useLazyResource(
    (documentId: string) =>
      companiesApi.profile.pitchDocuments
        .download(companyId, documentId, 'download')
        .then(response => downloadBlob(response)),
    {
      onFailure: () => notify('error', 'Could not download the document.'),
    },
  );
};
